const ARABIC_MONTHS = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

const riyadhNow = () => new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Riyadh' }));

const toIso = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

const addDays = (d, days) => { const c = new Date(d); c.setDate(c.getDate() + days); return c; };

export const PERIOD_PRESETS = [
  { key: 'today', label: 'اليوم' },
  { key: 'yesterday', label: 'بالأمس' },
  { key: 'last_week', label: 'الأسبوع الماضي' },
  { key: 'last_month', label: 'الشهر الماضي' },
  { key: 'this_month', label: 'هذا الشهر' },
  { key: 'this_year', label: 'هذه السنة' },
  { key: 'last_year', label: 'السنة الماضية' },
  { key: 'all', label: 'منذ البداية' },
  { key: 'custom', label: 'تحديد فترة مخصصة' },
];

// يبني نطاق تاريخ {startDate, endDate, label} بصيغة YYYY-MM-DD (أو null/null لـ"منذ البداية") حسب مفتاح الاختصار
export const resolvePreset = (key, custom) => {
  const now = riyadhNow();
  const today = toIso(now);
  switch (key) {
    case 'today':
      return { preset: key, startDate: today, endDate: today, label: 'اليوم' };
    case 'yesterday': {
      const y = toIso(addDays(now, -1));
      return { preset: key, startDate: y, endDate: y, label: 'بالأمس' };
    }
    case 'last_week':
      return { preset: key, startDate: toIso(addDays(now, -6)), endDate: today, label: 'الأسبوع الماضي' };
    case 'last_month': {
      const y = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
      const m = now.getMonth() === 0 ? 12 : now.getMonth();
      const start = new Date(y, m - 1, 1);
      const end = new Date(y, m, 0);
      return { preset: key, startDate: toIso(start), endDate: toIso(end), label: `${ARABIC_MONTHS[m - 1]} ${y}` };
    }
    case 'this_month': {
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      return { preset: key, startDate: toIso(start), endDate: toIso(end), label: `${ARABIC_MONTHS[now.getMonth()]} ${now.getFullYear()}` };
    }
    case 'this_year':
      return { preset: key, startDate: `${now.getFullYear()}-01-01`, endDate: `${now.getFullYear()}-12-31`, label: `سنة ${now.getFullYear()}` };
    case 'last_year':
      return { preset: key, startDate: `${now.getFullYear() - 1}-01-01`, endDate: `${now.getFullYear() - 1}-12-31`, label: `سنة ${now.getFullYear() - 1}` };
    case 'custom':
      return { preset: key, startDate: custom?.startDate || null, endDate: custom?.endDate || today, label: custom?.startDate ? `${custom.startDate} → ${custom.endDate || today}` : 'تحديد فترة مخصصة' };
    case 'all':
    default:
      return { preset: 'all', startDate: null, endDate: null, label: 'منذ البداية' };
  }
};

export const defaultPeriodRange = () => resolvePreset('this_month');
